const indentPadding = 24;

export const formItemStyle = uischema => {
  const paddingLeft = (uischema.options?.indentLevel || 0) * indentPadding;
  return { paddingLeft: paddingLeft };
};
